<script lang="ts">
  import { PUBLIC_PREVIEW } from "$env/static/public";
  import type { GlobalStoryblok, MetaStoryblok } from "$types/components";

  export let blok: MetaStoryblok;
  export let globals: GlobalStoryblok;

  let title = blok.title ?? "";

  if (
    globals.pageTitleSuffix &&
    !blok.noTitleSuffix &&
    !title.includes(" | ")
  ) {
    title += globals.pageTitleSuffix;
  }
</script>

{#if PUBLIC_PREVIEW === "true" || blok?.noindex}
  <meta name="robots" content="noindex" />
{/if}

{#if blok}
  <title>{title}</title>
  <meta name="description" content={blok.description} />
  <meta name="og:title" content={title} />
  <meta name="og:description" content={blok.description} />
  <meta property="og:type" content="website" />
  <meta
    property="og:image"
    content="{blok.share_image?.filename}/m/1200x600/smart"
  />
  <meta
    name="twitter:image"
    content="{blok.share_image?.filename}/m/1200x600/smart"
  />
  <meta name="twitter:card" content="summary_large_image" />
{/if}
